/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Free_TodayInputs */

const en_start_page_free_today = /** @type {(inputs: Start_Page_Free_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free today`)
};

const pl_start_page_free_today = /** @type {(inputs: Start_Page_Free_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne dziś`)
};

/**
* | output |
* | --- |
* | "Free today" |
*
* @param {Start_Page_Free_TodayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_free_today = /** @type {((inputs?: Start_Page_Free_TodayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Free_TodayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_free_today(inputs)
	return en_start_page_free_today(inputs)
});